var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90931 0.00523451L7 0C7.39884 0 7.72761 0.300253 7.77257 0.687073L7.77778 0.777778V6.22222H13.2222C13.6211 6.22222 13.9498 6.52244 13.9948 6.90931L14 7C14 7.39884 13.6998 7.72761 13.3129 7.77257L13.2222 7.77778H7.77778V13.2222C7.77778 13.6211 7.47756 13.9498 7.09069 13.9948L7 14C6.60116 14 6.27239 13.6998 6.22743 13.3129L6.22222 13.2222V7.77778H0.777778C0.378902 7.77778 0.050159 7.47756 0.00523451 7.09069L0 7C0 6.60116 0.300253 6.27239 0.687073 6.22743L0.777778 6.22222H6.22222V0.777778C6.22222 0.378902 6.52244 0.050159 6.90931 0.00523451Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.a2868025e157f104783dbfefef5d3350.svg";
export { ForwardRef as ReactComponent };